export default __webpack_public_path__ + "static/media/pop-up-stores.992ead40.png";